// const NEW_API_ENDPOINT = 'http://localhost:8000';
const NEW_API_ENDPOINT = process.env.REACT_APP_NEW_API_ENDPOINT;
export default NEW_API_ENDPOINT;
